'use client'

import type { Ref, TextareaHTMLAttributes } from 'react'
import { controlVariants } from './control'
import { useFieldControlProps } from './field'
import { cn } from '../../utils/cn'

/**
 * A multi-line text input.
 *
 * Height is a row count rather than a class, so a caller cannot make one
 * textarea in one app taller than everywhere else.
 */
export type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'className' | 'style'> & {
    /**
     * React 19 passes `ref` as an ordinary prop, so `forwardRef` is dead
     * weight. It also types cleanly under the consumers' compilers, where
     * `forwardRef(...)` plus a `displayName` assignment did not.
     */
    ref?: Ref<HTMLTextAreaElement>
}

export const Textarea = ({ rows = 4, ref, ...props }: TextareaProps) => (
    <textarea
        {...props}
        ref={ref}
        rows={rows}
        {...useFieldControlProps(props)}
        className={cn(controlVariants({ size: 'medium' }), 'h-auto resize-y py-2 leading-normal')}
    />
)
